import {t} from '@lingui/macro';
import { PermissionKey } from '../../../../../components/Access/helper/permission/enum/PermissionKey';
import { PermissionV2 } from '../../../../../components/Access/helper/permission/enum/PermissionV2';

export const PermissionInfo = {
    [PermissionKey.dashboard]:
        { title: () => t`Dashboard`, maxLevel: PermissionV2.read },

    [PermissionKey.sale]:
        { title: () => t`Sales`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.sale_quote]:
        { title: () => t`Quotations`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.sale_order]:
        { title: () => t`Sales Orders`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4']},

    [PermissionKey.sale_delivery_order]:
        { title: () => t`Delivery Orders`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.sale_invoice]:
        { title: () => t`Invoices`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.sale_credit_note]:
        { title: () => t`Credit Notes`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.sale_payment]:
        { title: () => t`Payments`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.sale_refund]:
        { title: () => t`Refunds`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.purchase]:
        { title: () => t`Purchases`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.purchase_order]:
        { title: () => t`Purchase Orders`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.purchase_goods_received_note]:
        { title: () => t`Goods Received Notes`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.purchase_bill]:
        { title: () => t`Bills`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.purchase_credit_note]:
        { title: () => t`Credit Notes`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.purchase_payment]:
        { title: () => t`Payments`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.purchase_refund]:
        {
            title: () => t`Refunds`,
            maxLevel: PermissionV2.delete,
            modifier: ['M1', 'M3', 'M4'],
        },

    [PermissionKey.shoebox]:
        { title: () => t`Digital Shoebox`, maxLevel: PermissionV2.delete },

    [PermissionKey.bank]:
        { title: () => t`Bank`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.bank_income]:
        { title: () => t`Money In`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.bank_expense]:
        { title: () => t`Money Out`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.bank_transfer]:
        { title: () => t`Transfers`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.bank_account]:
        { title: () => t`Accounts`, maxLevel: PermissionV2.delete },

    [PermissionKey.bank_feed]:
        { title: () => t`Bank Feeds`, maxLevel: PermissionV2.delete },

    [PermissionKey.contact]:
        { title: () => t`Contacts`, maxLevel: PermissionV2.delete },

    [PermissionKey.contact_customer]:
        { title: () => t`Customer`, maxLevel: PermissionV2.delete },

    [PermissionKey.contact_supplier]:
        { title: () => t`Supplier`, maxLevel: PermissionV2.delete },

    [PermissionKey.contact_employee]:
        { title: () => t`Employee`, maxLevel: PermissionV2.delete },

    [PermissionKey.product]:
        { title: () => t`Products`, maxLevel: PermissionV2.delete },

    [PermissionKey.stock]:
        { title: () => t`Stock`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.stock_adjustment]:
        { title: () => t`Adjustments`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.stock_transfer]:
        { title: () => t`Transfers`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.stock_value]:
        { title: () => t`Periodic Values`, maxLevel: PermissionV2.update, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.myinvois]:
        { title: () => t`MyInvois`, maxLevel: PermissionV2.update },

    [PermissionKey.report]:
        { title: () => t`Reports`, maxLevel: PermissionV2.read, modifier: ['M2'] },

    // Reports - Financial Reports
    [PermissionKey.report_balance_sheet]:
        { title: () => t`Balance Sheet`, maxLevel: PermissionV2.read },

    [PermissionKey.report_profit_loss]:
        { title: () => t`Profit Loss`, maxLevel: PermissionV2.read },

    [PermissionKey.report_cash_flow]:
        { title: () => t`Cash Flow Statement`, maxLevel: PermissionV2.read },

    [PermissionKey.report_financial_summary]:
        { title: () => t`Financial Summary`, maxLevel: PermissionV2.read },

    // Reports - Aging Reports
    [PermissionKey.report_aged_receivable]:
        { title: () => t`Aged Receivable`, maxLevel: PermissionV2.read },

    [PermissionKey.report_aged_payable]:
        { title: () => t`Aged Payable`, maxLevel: PermissionV2.read },

    // Reports - Sales Reports
    [PermissionKey.report_invoice_summary]:
        { title: () => t`Invoice Summary`, maxLevel: PermissionV2.read },

    [PermissionKey.report_sale_credit_note_summary]:
        { title: () => t`Sales Credit Note Summary`, maxLevel: PermissionV2.read },

    [PermissionKey.report_sale_payment_summary]:
        { title: () => t`Sales Payment Summary`, maxLevel: PermissionV2.read },

    [PermissionKey.report_sale_quote_by_customer]:
        { title: () => t`Quotations by Customer`, maxLevel: PermissionV2.read },

    [PermissionKey.report_sale_order_by_customer]:
        { title: () => t`Sale Orders by Customer`, maxLevel: PermissionV2.read },

    [PermissionKey.report_sale_delivery_order_by_customer]:
        { title: () => t`Delivery Orders by Customer`, maxLevel: PermissionV2.read },

    [PermissionKey.report_sale_by_customer]:
        { title: () => t`Sales Summary by Customer`, maxLevel: PermissionV2.read },

    [PermissionKey.report_sale_by_tag]:
        { title: () => t`Sales by Tag`, maxLevel: PermissionV2.read },

    // Reports - Purchase Reports
    [PermissionKey.report_bill_summary]:
        { title: () => t`Bill Summary`, maxLevel: PermissionV2.read },

    [PermissionKey.report_purchase_credit_note_summary]:
        { title: () => t`Purchase Credit Note Summary`, maxLevel: PermissionV2.read },

    [PermissionKey.report_purchase_payment_summary]:
        { title: () => t`Purchase Payment Summary`, maxLevel: PermissionV2.read },

    [PermissionKey.report_purchase_order_by_supplier]:
        { title: () => t`Purchase Orders by Supplier`, maxLevel: PermissionV2.read },

    [PermissionKey.report_purchases_by_supplier]:
        { title: () => t`Purchase Summary by Supplier`, maxLevel: PermissionV2.read },

    // Reports - Payment Reports
    [PermissionKey.report_official_receipt_summary]:
        { title: () => t`Official Receipt Summary`, maxLevel: PermissionV2.read },

    [PermissionKey.report_payment_voucher_summary]:
        { title: () => t`Payment Voucher Summary`, maxLevel: PermissionV2.read },

    [PermissionKey.report_cash_sales_summary]:
        { title: () => t`Cash Sales Summary`, maxLevel: PermissionV2.read },

    [PermissionKey.report_cash_purchase_summary]:
        { title: () => t`Cash Purchase Summary`, maxLevel: PermissionV2.read },

    // Reports - Product Reports
    [PermissionKey.report_product_sale]:
        { title: () => t`Product Sales`, maxLevel: PermissionV2.read },

    [PermissionKey.report_product_bundle_sale]:
        { title: () => t`Product Bundle Sales`, maxLevel: PermissionV2.read },

    [PermissionKey.report_product_purchase]:
        { title: () => t`Product Purchase`, maxLevel: PermissionV2.read },

    [PermissionKey.report_item_sales_collection]:
        { title: () => t`Item Sales Collection`, maxLevel: PermissionV2.read },

    // Reports - Inventory Reports
    [PermissionKey.report_inventory]:
        { title: () => t`Inventory`, maxLevel: PermissionV2.read, modifier: ["M2"] },

    [PermissionKey.report_profit_summary]:
        { title: () => t`Profit Summary`, maxLevel: PermissionV2.read, modifier: ["M2"] },

    [PermissionKey.report_profit_detail]:
        { title: () => t`Profit Detail`, maxLevel: PermissionV2.read, modifier: ["M2"] },

    // Reports - Fixed Asset Reports
    [PermissionKey.report_asset]:
        { title: () => t`Fixed Asset, Depreciation, and Disposal`, maxLevel: PermissionV2.read },

    // Reports - Ledger Reports
    [PermissionKey.report_general_ledger]:
        { title: () => t`General Ledger`, maxLevel: PermissionV2.read },

    [PermissionKey.report_debtor_ledger]:
        { title: () => t`Debtor Ledger`, maxLevel: PermissionV2.read },

    [PermissionKey.report_creditor_ledger]:
        { title: () => t`Creditor Ledger`, maxLevel: PermissionV2.read },

    // Reports - SST Reports
    [PermissionKey.report_sst]:
        { title: () => t`SST`, maxLevel: PermissionV2.read },

    // Accounting Reports
    [PermissionKey.report_journal_entry_detail]:
        { title: () => t`Journal Entry Detail`, maxLevel: PermissionV2.read },

    [PermissionKey.report_double_entry_detail]:
        { title: () => t`Double Entry Detail`, maxLevel: PermissionV2.read },

    [PermissionKey.report_trial_balance]:
        { title: () => t`Trial Balance`, maxLevel: PermissionV2.read },

    [PermissionKey.report_bank_reconciliation]:
        { title: () => t`Bank Reconciliation & Reconciled Transactions`, maxLevel: PermissionV2.read },

    [PermissionKey.report_transaction_list]:
        { title: () => t`Transaction List`, maxLevel: PermissionV2.read },

    [PermissionKey.report_exchange_gain_loss]:
        { title: () => t`Exchange Gain/Loss & Unrealised Exchange Detail`, maxLevel: PermissionV2.read },

    [PermissionKey.report_exchange_rates]:
        { title: () => t`Exchange Rates`, maxLevel: PermissionV2.read },

    [PermissionKey.report_audit_trail]:
        { title: () => t`Audit Trail`, maxLevel: PermissionV2.read },

    [PermissionKey.report_chart_of_accounts]:
        { title: () => t`Chart of Accounts`, maxLevel: PermissionV2.read },

    // Accounting
    [PermissionKey.accounting]:
        { title: () => t`Accounting`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.accounting_journal_entry]:
        { title: () => t`Journal Entries`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.accounting_contra]:
        { title: () => t`Contra`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.accounting_fixed_asset]:
        { title: () => t`Fixed Assets`, maxLevel: PermissionV2.delete },

    [PermissionKey.accounting_deemed_payment]:
        { title: () => t`Deemed Payments`, maxLevel: PermissionV2.delete, modifier: ['M1', 'M3', 'M4'] },

    [PermissionKey.accounting_chart_of_account]:
        { title: () => t`Chart of Accounts`, maxLevel: PermissionV2.delete },

    [PermissionKey.flow]:
        { title: () => t`Flow`, maxLevel: PermissionV2.delete },

    [PermissionKey.control_panel]:
        { title: () => t`Control Panel`, maxLevel: PermissionV2.delete },

    [PermissionKey.cp_app]:
        { title: () => t`Apps`, maxLevel: PermissionV2.delete },

    [PermissionKey.cp_instruction]:
        { title: () => t`Recurring Instructions`, maxLevel: PermissionV2.delete },

    [PermissionKey.cp_payment_term]:
        { title: () => t`Payment Terms`, maxLevel: PermissionV2.delete },

    [PermissionKey.cp_payment_method]:
        { title: () => t`Payment Methods`, maxLevel: PermissionV2.delete },

    [PermissionKey.cp_currency]:
        { title: () => t`Currencies`, maxLevel: PermissionV2.delete },

    [PermissionKey.cp_asset_type]:
        { title: () => t`Asset Types`, maxLevel: PermissionV2.delete },

    [PermissionKey.cp_location]:
        { title: () => t`Locations`, maxLevel: PermissionV2.delete },

    [PermissionKey.cp_number_format]:
        { title: () => t`Number Formats`, maxLevel: PermissionV2.delete },

    [PermissionKey.cp_form_design]:
        { title: () => t`Form Designs`, maxLevel: PermissionV2.delete },

    [PermissionKey.cp_custom_field]:
        { title: () => t`Custom Fields`, maxLevel: PermissionV2.delete },

    [PermissionKey.cp_price_level]:
        { title: () => t`Price Levels`, maxLevel: PermissionV2.delete },

    [PermissionKey.cp_tag]:
        { title: () => t`Tags`, maxLevel: PermissionV2.delete },

    [PermissionKey.cp_company_profile]:
        { title: () => t`Company Profile`, maxLevel: PermissionV2.update },

    [PermissionKey.cp_company_setting]:
        { title: () => t`Company Settings`, maxLevel: PermissionV2.update },

    [PermissionKey.cp_flow_setting]:
        { title: () => t`Flow Streams`, maxLevel: PermissionV2.delete },

    [PermissionKey.cp_shoebox_setting]:
        { title: () => t`Shoebox Settings`, maxLevel: PermissionV2.update },

    [PermissionKey.cp_integration]:
        { title: () => t`Integration`, maxLevel: PermissionV2.update },

    [PermissionKey.cp_backup_data]:
        { title: () => t`Backup Data`, maxLevel: PermissionV2.read },

    [PermissionKey.store]:
        { title: () => t`Bukku Store`, maxLevel: PermissionV2.delete },

    [PermissionKey.minipos]:
        { title: () => t`MiniPOS`, maxLevel: PermissionV2.delete },
};
